import { create } from "zustand";

type DoubleClickStore = {
  doubleClick: boolean;
  setDoubleClick: (arg: boolean) => void;
};

export const useDoubleClickStore = create<DoubleClickStore>((set) => ({
  doubleClick: false,
  setDoubleClick: (arg) => set({ doubleClick: arg }),
}));
